export var ScreenEvents;
(function (ScreenEvents) {
    ScreenEvents["SCREEN_REGISTERED"] = "screen:registered";
    ScreenEvents["SCREEN_CONNECTED"] = "screen:connected";
    ScreenEvents["SCREEN_DISCONNECTED"] = "screen:disconnected";
    ScreenEvents["SCREEN_UPDATED"] = "screen:updated";
    ScreenEvents["SCREEN_TEMPLATE_UPDATED"] = "screen:template_updated";
    ScreenEvents["SCREEN_LOCATE"] = "screen:locate";
    ScreenEvents["SCREEN_CONFIGURATION_UPDATED"] = "screen:configuration_updated";
})(ScreenEvents || (ScreenEvents = {}));
